import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule,HttpClient } from '@angular/common/http';
/*import { MatToolbarModule, MatIconModule, MatSidenavModule, MatListModule, MatButtonModule, MatTabsModule, MatStepperModule, MatFormFieldModule, MatInputModule, MatRadioModule, MatCheckboxModule, MatCardModule } from  '@angular/material'; */
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatListModule} from '@angular/material/list';
import {MatButtonModule} from '@angular/material/button';
import {MatTabsModule} from '@angular/material/tabs';
import {MatStepperModule} from '@angular/material/stepper';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatCardModule} from '@angular/material/card';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { LayoutComponent } from './layout/layout.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule  } from 'ngx-toastr';
import { ApplicationComponent, KeysPipe } from './application/application.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import {  MatTableModule } from '@angular/material/table';
import * as $ from 'jquery';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AmChartsModule } from "@amcharts/amcharts3-angular";
//import { UserIdleModule } from 'angular-user-idle';
import { BnNgIdleService } from 'bn-ng-idle';
import { AuthGuardService } from './auth-guard.service';
import {TooltipModule} from "ngx-tooltip";
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { ConnectorComponent } from './connector/connector.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'; 
import { MessageComponent } from './message/message.component';
import {AdminComponent} from './admin/admin.component';
import { NgxPaginationModule } from 'ngx-pagination';
import {PaginationComponent} from './pagination/pagination.component';
import {MessagesComponent} from './messages/messages.component';
import { MessageHeaderComponent } from './message-header/message-header.component';
import { OverviewComponent } from './overview/overview.component';
import { ResellerViewComponent } from './reseller-view/reseller-view.component';
import { ResellermessagecountComponent } from './resellermessagecount/resellermessagecount.component';
import { MonthlyActiveUserComponent } from './monthly-active-user/monthly-active-user.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { WhatsappPricingComponent } from './whatsapp-pricing/whatsapp-pricing.component';
import { WhatsappEmbeddedSignupComponent } from './whatsapp-embedded-signup/whatsapp-embedded-signup.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import {MatProgressBarModule} from '@angular/material/progress-bar';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}


 

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LayoutComponent,
    ApplicationComponent,
    HeaderComponent,
    FooterComponent,
    ConnectorComponent,
    DashboardComponent,
    MessageComponent,
    AdminComponent,
    PaginationComponent,
    MessagesComponent,
    MessageHeaderComponent,
    OverviewComponent,
    ResellerViewComponent,
    ResellermessagecountComponent,
    MonthlyActiveUserComponent,
    WhatsappPricingComponent,
    WhatsappEmbeddedSignupComponent,
    KeysPipe
    // SanitizerUrlPipe
    ],
  imports: [
    NgxPaginationModule,
    NgSelectModule,
    BrowserModule,
    AppRoutingModule,
  FormsModule,
  MatTableModule,
	ReactiveFormsModule,
	HttpClientModule,
	BrowserAnimationsModule,
	MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatButtonModule,
    TooltipModule,
	MatTabsModule,
	MatStepperModule,
	MatFormFieldModule,
	MatInputModule,
	MatRadioModule,
	MatCheckboxModule,
	MatCardModule,
    MatIconModule,
	ToastrModule.forRoot(),
	NgbModule,
  PopoverModule.forRoot(),
  MatProgressBarModule,
// 	AngularFontAwesomeModule,
  TranslateModule.forRoot({
    loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
    }
}),
	BsDatepickerModule.forRoot(),
	AmChartsModule,
	FontAwesomeModule
	//UserIdleModule.forRoot({idle: 60, timeout: 120, ping: 60})
  ],
  providers: [AuthGuardService,BnNgIdleService],
  bootstrap: [AppComponent]
})
export class AppModule { }

